import { render, staticRenderFns } from "./bloodPressure.vue?vue&type=template&id=2d9cdc1a"
import script from "./bloodPressure.vue?vue&type=script&lang=js"
export * from "./bloodPressure.vue?vue&type=script&lang=js"
import style0 from "./bloodPressure.vue?vue&type=style&index=0&id=2d9cdc1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports